export const GENERIC_ERROR_HEADER = "We're having trouble with the forms.";
export const GENERIC_ERROR_MESSAGE =
  "Try refreshing this page. If that doesn't work, try again later.";
export const BLANK = "";
export const UNKNOWN = "Unknown";
export const APPROVED = "Approved";
export const IN_PROGRESS = "In Progress";
export const BOARDING_IN_PROGRESS = "Boarding InProgress";
export const DECLINED = "Declined";
export const WITHDRAWN = "Withdrawn";
export const ERROR = "Error";
export const TIMED_OUT_RESP = "Timed_Out";
export const TIMED_OUT = "Timed Out";
export const PARTIAL_COMPLETE = "Partial Complete";
export const PENDING = "Pending";
export const BOARDING = "Boarding";
export const SUBMITTED = "Submitted";
export const PRIVACY_TOKEN_CONFIRMATION = "CONFIRMED";
export const cookieName = "privacy_optout";
export const ELAVON_COOKIE_DOMAIN = ".elavon.com";
export const PRIVACY_OPT_ERROR_MSG_INVALID_EMAIL =
  "Please enter a valid email.";
export const PRIVACY_OPT_ERROR_MSG_CONFIRMATION = "error";
export const PRIVACY_OPT_SUCCESS_MSG = "You have successfully opted-out.";
export const PRIVACY_OPT_MSG_CONFIRMATION = "success";
export const PRIVACY_OPT_ERROR_MSG =
  "Something wrong, Please try again after sometime";
export const CLOSE_MODAL_LABEL = "cancel modal";
export const PRIVACY_OPTOUT = "PrivacyOptOut";
export const PRIVACY_OPT_EMAIL_INPUT = "privacy_email_input";
export const PRIVACY_EMAIL_INPUT_LABEL = "Email address";
export const labelledBy = "modal-title";
export const describedBy = "modal-description";
export const OPT_OUT_SUCCESS = "SUCCESS";
export const SUPPORT_MENU_LABEL = "Support";
export const ELAVON_ACCESS_LABEL = "Log in";
export const NEED_HELP_LABEL = "Need help?";
export const FORGOT_PASS_LABEL = "Forgot password";
export const RESEND_REG_LABEL = "Resend registration email";
